import React, { useState, createContext, useEffect } from "react";
import ReactDOM from 'react-dom';
import * as Survey from "survey-react"
import "survey-react/modern.css";
import "survey-react/survey.css";
import "../index.css";
import SurveyContainer from "../components/survey"
import Amplify, { Auth } from "aws-amplify";
import awsExports from "../aws-exports";
import { withAuthenticator } from '@aws-amplify/ui-react'
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
Amplify.configure(awsExports);
const PatientPortal = (props) => {
    const [idToken, setIdToken] = useState('')

    useEffect(() => {
        Auth.currentSession().then((res) => {
            let accessToken = res.getAccessToken();
            let jwt = accessToken.getJwtToken();
            //You can print them to see the full objects
            console.log(res)
            console.log(`myAccessToken: ${JSON.stringify(accessToken)}`);
            console.log(`myJwt: ${jwt}`);
            setIdToken(res.getIdToken().jwtToken)
            console.log(res.getIdToken())
            console.log(idToken)

        });
    }, []);
    async function signOut() {
        try {
            await Auth.signOut();
            window.location.reload()
        } catch (error) {
            console.log('error signing out: ', error);
        }
    }
    
    return (
        <div>
            <h1>Patient Portal</h1>
            <Button color="primary" variant="contained" onClick={() => { signOut(); }}>
                Sign out
            </Button>
            <SurveyContainer auth={idToken} />

        </div>

    );
}
export default withAuthenticator(PatientPortal)
